module.exports = "data:image/gif;base64,R0lGODlhBQAFAKIAAAAAAP///4KYx4yhzM3W6P///wAAAAAAACH5BAEAAAUALAAAAAAFAAUAAAMJSCOj8utB2VZLADs="